import {createContext} from 'react';

export const UserContext = createContext({user: "f.rudberg@gmail.com"})